import React, { Component } from 'react';
import { Modal, ModalBody } from "reactstrap";
import i18n from './../../i18n';
import { withTranslation } from 'react-i18next';
import ReactSVG from 'react-svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Alert } from 'reactstrap';
import { Link, Redirect } from "react-router-dom";
import Button from './../../components/button';

import { getRooms, getRoom, setRoomLanguage, doorIOEvent, updateRoomStatus } from './../../models/room';
import { getSection } from './../../models/section';
import SignalR from './../../components/signalr';

import Clock from './../../components/clock';
import ZmanTevilah from './../../components/zman-tevilah';
import ScreenPrep from './../../components/screen-prep';
import ScreenAssigned from './../../components/screen-assigned';
import ScreenReady from './../../components/screen-ready';
import ScreenReadyChecking from './../../components/screen-ready-checking';
import ScreenChecking from './../../components/screen-checking';
import ScreenChecked from './../../components/screen-checked';
import ScreenToMikvah from './../../components/screen-to-mikvah';
import ScreenDressing from './../../components/screen-dressing';
import ScreenNeedsCleaning from './../../components/screen-needscleaning';
import ScreenCleaning from './../../components/screen-cleaning';
import ScreenDone from './../../components/screen-done';
import RoomNumber from './../../components/snippets/room-number';
import ReservationNumber from './../../components/snippets/room-reservation';
import RoomStatus from './../../components/snippets/room-status';
import RoomAttendant from './../../components/snippets/room-attendant';
import RoomArrived from './../../components/snippets/room-arrived';
import RoomButtons from './../../components/room-buttons';
import globeIcon from "./../../assets/images/icon-globe.svg";
import iconClose from "./../../assets/images/icon-close.svg";
import Loader from './../../components/snippets/loader';
import ScreenSaver from '../../components/screensaver';
import RoomAdmin from './../../components/room-admin';
import StaffCode from './../../components/staffCode';
import SpecialMode from './../../components/special-mode';
import ErevYomKippurMode from './../../components/erevYomKippurMode';
import NotificationSoundFile from './../../assets/sounds/notification.mp3';
import AttentionSoundFile from './../../assets/sounds/attention.mp3';
import { SettingsContext } from './../../components/context';
import LanguageSelector from './../../components/language-selector';
import { NotificationAudioManager } from './../../components/NotificationAudioManager.js';
import moment from 'moment';

function Screen(props) {
  switch (props.room.status) {
    case 'Assigned':
      return <ScreenAssigned room={props.room} handleUpdateRoom={props.handleUpdateRoom} playSound={props.playSound}/>;
    case 'Prep':
      return <ScreenPrep room={props.room} settings={props.settings} handleUpdateRoom={props.handleUpdateRoom} playSound={props.playSound}/>;
    case 'ReadyForChecking':
    case 'ReadyForCheckingNext':
      return <ScreenReadyChecking room={props.room} handleUpdateRoom={props.handleUpdateRoom}/>
    case 'Checking':
      return <ScreenChecking room={props.room} section={props.section} isLoadedSection={props.isLoadedSection} handleUpdateRoom={props.handleUpdateRoom}/>
    case 'Checked':
      return <ScreenChecked room={props.room} handleUpdateRoom={props.handleUpdateRoom}/>
    case 'ReadyForMikvah':
    case 'ReadyForMikvahNext':
      return <ScreenReady room={props.room} settings={props.settings} section={props.section} isLoadedSection={props.isLoadedSection} handleUpdateRoom={props.handleUpdateRoom}/>
    case 'ToMikvah':
      return <ScreenToMikvah room={props.room} handleUpdateRoom={props.handleUpdateRoom}/>;  
    case 'Dressing':
      return <ScreenDressing room={props.room} settings={props.settings} siteSettings={props.siteSettings} handleUpdateRoom={props.handleUpdateRoom} playSound={props.playSound}/>
    case 'Done':
      return <ScreenDone room={props.room} settings={props.settings} handleUpdateRoom={props.handleUpdateRoom}/>  
    case 'NeedsCleaning':
      return <ScreenNeedsCleaning room={props.room} handleUpdateRoom={props.handleUpdateRoom}/>
    case 'Cleaning':
      return <ScreenCleaning room={props.room} handleUpdateRoom={props.handleUpdateRoom}/>
    case 'Offline':
    case 'Ready':
      return props.settings && props.settings.roomsUseStaffEntry.value=="True"?
      <StaffCode emptyRoom={true} room={props.room} handleUpdateRoom={props.handleUpdateRoom}/>
      :null
    default:
      return null
  }
}

class RoomView extends Component {
  static contextType = SettingsContext;

  constructor(props) {
    super(props);
    this.state = {
      error: null,
      isLoaded: false,
      isLoadedSection: false,
      connection: null,
      currentLanguage: i18n.language,
      modal: false,
      modalLangClass: "",
      time: moment().format(),
      screenMuted: JSON.parse(localStorage.getItem('screenMuted'))
    };
    this.changeLanguage = this.changeLanguage.bind(this);
    this.handleUpdateRoom = this.handleUpdateRoom.bind(this);
    this.handlePlaySound = this.handlePlaySound.bind(this);
    this.handleEmergency = this.handleEmergency.bind(this);
    this.handleMusic = this.handleMusic.bind(this);
    this.unmuteScreen = this.unmuteScreen.bind(this);
    this.notificationSound = new Audio(NotificationSoundFile);
    this.savedReservation = {parking: false}
    this.audioManager = new NotificationAudioManager(
      props,
      i18n,
      this.notificationSound,
      this.roomMusic
    );
  }

  componentDidMount() {
    this.setUpTick();
    if ( this.props.id ) {
      this.retrieveRoom();
      this.getLanguage();
    } else {
      let savedSelectedRoom = localStorage.getItem('selectedRoom');
      if ( savedSelectedRoom ) {
        this.setState({savedSelectedRoom});
        return;
      } else {
        this.retrieveRooms();
      }
    }
  }
  
  componentDidUpdate(prevProps) {
    if (prevProps.id!==this.props.id) {
      this.retrieveRoom();
      this.setState({error: null})
    }
  }
  
  componentWillUnmount() {
    if ( this.props.id ) {
      if(this.roomMusic){
        this.roomMusic.pause();
        this.roomMusic.src = '';
        this.roomMusic = null;
      }
    }
  }

  setUpTick() {
    this.intervalID = setInterval(
      () => this.tick(),
      60000
    );
  }

  tick() {
    this.setState({
      time: moment().format(),
    });
  }

  getLanguage = (showModal) => {
    let language = localStorage.getItem('selectedLanguage');
    if(language) {
      i18n.changeLanguage(language);
      moment.locale(language);
      this.setState({currentLanguage: language})
    } else {
      if (showModal) {
        this.setState({modal: true});
      }
    }
  }

  retrieveRooms() {
    getRooms()
      .then(
        result => {
          let rooms = result;
          this.setState({
            isLoadedRooms: true,
            rooms: rooms,
          });
        },
        error => {
          this.setState({
            isLoadedRooms: true,
            error
          });
        }
      );
  }

  
  retrieveRoom() {
    const { settings } = this.context;
    const { siteSettings } = this.props;

    getRoom(this.props.id)
      .then(
        result => {
          let room = result;
          if ( room.effectiveStatus==="Assigned" ) {
            if (room.reservation && room.reservation.user && room.reservation.user.phoneNumber.slice(-10)!=='0000000000' && room.reservation.user.language) {
              this.changeLanguage(room.reservation.user.language);
            } else{
              if(siteSettings.defaultRoomLanguage){
                this.changeLanguage(siteSettings.defaultRoomLanguage);
              } else {
                this.getLanguage(true);
              }
            }
          }
          if ( room.effectiveStatus==="Prep" && this.state.room && this.state.room.effectiveStatus==="Assigned" ) {
            this.handlePlaySound(false, false, false, false, false, true);
          }
          if ( ["NeedsCleaning", "Ready", "Offline"].includes(room.effectiveStatus) ) {
            this.clearRoomPreferences();
          }
          if ( ["Done", "NeedsCleaning", "Cleaning", "Ready", "Offline"].includes(room.effectiveStatus) ) {
            if(room.dryDoorLocked){
              this.handlePlaySound(false, false, false, false, true);
            }
          }
          if( room.effectiveStatus==="Done" && this.state.room && this.state.room.reservation.okToExit!==room.reservation.okToExit) {
            if(!this.state.screenMuted){
              if(this.roomMusic){
                this.roomMusic.pause();
              }
              this.notificationSound.play();
              if(this.roomMusic){
                setTimeout(()=>this.roomMusic.play(),1500);
              }
            }        
          }
          // if signalr for room update and in status that requires knowing about section then get section update
          if(["Checking", "ReadyForMikvah", "ReadyForMikvahNext"].includes(room.effectiveStatus) || (room.reservation && room.reservation.attendantInRoom && room.directToBor)){
            getSection(room.section.id)
              .then(
                result => {
                  let section = result;
                  this.setState({section, isLoadedSection: true})
                }
              )
          }
          if(!["Assigned", "Done", "NeedsCleaning", "Cleaning", "Ready", "Offline"].includes(room.effectiveStatus)){
            if(!room.dryDoorLocked && !room.privateRoom && (!room.wetDoorOnly || (room.wetDoorOnly&&!['ReadyForMikvah', 'ReadyForMikvahNext', 'ReadyForChecking', 'ReadyForCheckingNext'].includes(room.status)&&!room.needsSupplies)) && (settings&&settings.accesscontrolTempNoSensors&&settings.accesscontrolTempNoSensors.value==='False')){
              this.setState({playLockDoor: true});
              setTimeout(() => this.handlePlaySound(false, false, false, true), ['ReadyForMikvah', 'ReadyForMikvahNext', 'ReadyForChecking', 'ReadyForCheckingNext'].includes(room.status)?5000:0);
            } else{
              this.setState({playLockDoor: false})
            }
          }
          this.setState({
            isLoaded: true,
            room: room,
          });
        },
        error => {
          this.setState({
            isLoaded: false,
            error
          });
        }
      );
  }

  handleUpdateRoom(room) {
    let updatedRoom = {...room};
    this.setState({room: updatedRoom});
  }

  handleEmergency() {
    if(!this.state.room.emergencyCall){
      let body = {deviceName: `room ${this.props.id} emergency`, action: 'closed'};
      doorIOEvent(this.props.id, body)
        .then(result => {
        }, error => {
          this.setState({error: error })
        });
    } else{
      updateRoomStatus(this.props.id, 'ClearEmergencyCall')
        .then(
          result => {
          },
          error => {
            this.setState({
              error
            });
          }
        );  
    }
  }

  changeLanguage = (lng) => {
    i18n.changeLanguage(lng);
    moment.locale(lng);
    this.setState({
      currentLanguage: i18n.language,
      modalLangClass: "slide-out-bck-br scale-down-br"
    })
    setRoomLanguage(this.props.id,lng)
      .then(
        result => { 
        },
        error => {
          this.setState({
            isLoaded: false,
            error
          });
        }
      )

    localStorage.setItem('selectedLanguage', lng);
    setTimeout(() => this.setState({modal: false, modalLangClass: ''}), 400);
  }

  clearRoomPreferences = () => {
    const { settings } = this.context;
    const defaultLanguage = settings&&settings.defaultLanguage&&settings.defaultLanguage.value

    localStorage.removeItem('selectedLanguage');
    localStorage.removeItem('timerEndTime');
    localStorage.removeItem('timerTimeLeft');
    localStorage.removeItem('screenMuted');
    // Put room back into default language for cleaners
    i18n.changeLanguage(defaultLanguage);
    this.setState({currentLanguage: null});
    if(this.roomMusic){ 
      this.roomMusic.pause();
      this.roomMusic.src = '';
      this.roomMusic = null;
      this.audioManager.setRoomMusic(null);
    }
  }

  handleRoomSelected = (roomId) => {
    localStorage.setItem('selectedRoom', roomId);
  }

  handlePlaySound(next, newReadyPosition, lockDoor, lockDoorAgain, wrongRoom, greeting, goodbye) {
    if(!this.state.screenMuted){
      const { room } = this.state;
      let type;
      if(next){
        type = next.status&&next.status.includes("Checking")?'bedikah':'tevilah';
        this.audioManager.playNotification({ type, next: true });
      } else if(lockDoor){
        this.audioManager.playNotification({ lockDoor: true });
      } else if(lockDoorAgain){
        this.audioManager.playNotification({ lockDoorAgain: true });
      } else if(wrongRoom){
        this.audioManager.playNotification({ wrongRoom: true });
      } else if(greeting){
        this.audioManager.playNotification({ greeting: true });
      } else if(goodbye){
        this.audioManager.playNotification({ goodbye: true });
      } else if(newReadyPosition){
        type = newReadyPosition.status&&newReadyPosition.status.includes("Checking")?'bedikah':'tevilah';
        this.audioManager.playNotification({ type, index: newReadyPosition.position });
      }
    }
  }

  handleMusic(link,volume,updateVolume,mute=false, unmute=false) {
    if(mute){
      localStorage.setItem('screenMuted', 'true');
      this.setState({screenMuted: true});
      if(this.roomMusic){
        this.roomMusic.volume = 0;
      }
    } else if(unmute) {
      localStorage.removeItem('screenMuted');
      this.setState({screenMuted: false});
      if(this.roomMusic){
        this.roomMusic.volume = this.state.room.reservation.audioVolume*.01;
      } else {
        this.roomMusic = new Audio(this.state.room.reservation.audioStream&&this.state.room.reservation.audioStream.streamUrl);
        this.roomMusic.volume = this.state.room.reservation.audioVolume?this.state.room.reservation.audioVolume*.01:0;
        this.roomMusic.play();
        this.audioManager.setRoomMusic(this.roomMusic);
      }
    }
    if(!this.state.screenMuted&&!mute){
      if(!updateVolume){
        if(this.roomMusic){
          if(link){
            this.roomMusic.src = link;
            this.roomMusic.play();
          } else {
            this.roomMusic.pause();
          }
        } else{
          this.roomMusic = new Audio(link);
          this.roomMusic.volume = volume?volume*.01:0;
          this.roomMusic.play();
          this.audioManager.setRoomMusic(this.roomMusic);
        }
      } else if(this.roomMusic && Number.isInteger(volume)){
        this.roomMusic.volume = volume*.01;
      }
    }
  }

  unmuteScreen() {
    localStorage.removeItem('screenMuted');
    this.setState({screenMuted: false});
    if(this.roomMusic){
      this.roomMusic.volume = this.state.room.reservation.audioVolume*.01;
    }
  }

  render() {
    const { settings } = this.context;
    const { t, i18n, localProps, siteSettings } = this.props;
    const { error, isLoaded, isLoadedSection, room, section, playLockDoor, currentLanguage, isLoadedRooms, rooms, time } = this.state;
    let lastStatusChange = moment.duration(moment(time).subtract(settings&&settings.offset&&settings.offset.value,'seconds').diff(room&&room.effectiveStatusLastChange));
    if ( this.state.savedSelectedRoom ) {
      return <Redirect to={`/room/${this.state.savedSelectedRoom}`} />;
    }
    if ( !this.props.id || this.props.id==='0' ) {
      return <div className={'container-page lang-' + i18n.language}>
        <header className="header">
          <div>
            <div className="header-left"></div>
            <div className="header-center">
              <Clock />
            </div>
            <div className="header-right"></div>
          </div>
        </header>
        <div className="mx-auto text-center" style={{width:"1000px"}}>
          <div className="container-body text-center">
            <h3 className="text-uppercase">{t("Please choose a room")}:</h3>
            <div className="d-flex flex-wrap justify-content-center">
              {isLoadedRooms && rooms.map((room,i) => {
                return <Link to={"/room/" + room.id} className="m-2" key={i} onClick={()=>this.handleRoomSelected(room.id)}><Button type="circle" text={room.id} /></Link>;
              })}
            </div>
          </div>
        </div>
      </div>;
    } else {
      if (error) {
        return <div className={'container-page vh-100 d-flex justify-content-center lang-' + i18n.language}>
          <SignalR setRoom={this.props.id} />
          <div className="w-50 mx-auto text-center">
            <Alert color="danger">{t(error)} <span className="alert-link mis-2" onClick={()=>window.location.reload()}>{t("Try again")}</span></Alert>
          </div>
        </div>;
      } else if (!isLoaded) {
        return <div className={'container-page vh-100 d-flex justify-content-center lang-' + i18n.language}>
          <SignalR setRoom={this.props.id} />
          <div className="w-50 mx-auto text-center">
            <Loader />
          </div>
        </div>;
      } else {
        return (
          <SettingsContext.Consumer>
            {({settings}) => 
              <div className={'container-page view-room status-' + room.effectiveStatus.toLowerCase() + ' lang-' + i18n.language}>
                <SignalR setRoom={this.props.id} onRoomUpdated={() => this.retrieveRoom()} onYouAreNext={(s) => this.handlePlaySound(s)} onNewReadyPosition={(s) => this.handlePlaySound(false, s)} />
                <RoomAdmin room={room} handleUpdateRoom={this.handleUpdateRoom} settings={settings}/>
                {settings && settings.testMode && settings.testMode.value==="True"?
                  <div className="testMode">{t("System is currently in Test Mode")}</div>
                :null}
                {settings!==null && settings.erevYomKippurMode && settings.erevYomKippurMode.value === 'True'?(
                  <ErevYomKippurMode room={room} />
                ):settings!==null&&
                ['Friday', 'ErevYomTov'].includes(settings.scheduleType.value)&&moment(time).subtract(settings.offset&&settings.offset.value,'seconds').isAfter(moment(settings.openTime.value).subtract(1,'hours'))&&room.reservation===null&&room.roomStatus==="Ready"?(
                  <SpecialMode room={room} type={settings.scheduleType.value} />
                ):(
                  <>
                    {["Ready","Offline","NeedsCleaning"].includes(room.status) && !room.staff?
                      room.effectiveStatus!=='NeedsCleaning'||(room.effectiveStatus=='NeedsCleaning'&&lastStatusChange.asMinutes()>30)?
                        <ScreenSaver logo={this.props.logoWhite} logoImageAltText={this.props.logoImageAltText} />
                      :null
                    :null}
                    <header className="header">
                      <div>
                        <div className="header-left">
                          <RoomNumber number={room.id} />
                          {room.reservation ?
                          <ReservationNumber number={room.reservation.reservationCode} />
                          : null}
                        </div>
                        <div className="header-center">
                          <Clock />
                        </div>
                        <div className="header-right">
                          <RoomStatus status={t(room.statusName)} color={room.statusColor} />
                        </div>
                      </div>
                      <div>
                        <div className="header-left">
                          {room.reservation ?
                          <RoomArrived arrived={room.reservation.timeArrived} />
                          : null}
                          {room.staff?
                            <div>{t("Staff")}: {room.staff.firstName} {room.staff.lastName}</div>
                          :null}
                        </div>
                        <div className="header-center header-zman">
                          <ZmanTevilah showShkia={siteSettings.showShkiaRoomScreen} showFridayClosing={settings&&settings.fridayPrep&&settings.fridayPrep.value==="True"&&settings.shabbosMode&&settings.shabbosMode.value===true} showCandleLighting={settings&&settings.fridayPrep&&settings.fridayPrep.value==="True"&&settings.shabbosMode&&settings.shabbosMode.value===true} settings={settings} />
                        </div>
                        <div className="header-right">
                          <RoomAttendant attendant={room.section.attendant} helper={room.section.helper} hide={siteSettings.hideAttendantNameInRoom} />
                        </div>
                      </div>
                    </header>
                    <div className="container-body">
                      <LanguageSelector currentLanguage={currentLanguage} handleLanguageUpdated={this.changeLanguage}/>
                      <Modal
                        isOpen={this.state.modal}
                        size="full"
                        className={"modal-language" + this.state.modalLangClass}
                      >
                        <ModalBody>
                          <ReactSVG
                            className="icon"
                            src={globeIcon}
                            alt="Globe Icon"
                          />
                          <h4 className="modal-title">Select Language</h4>
                          <h4 className="modal-title">בחר שפה</h4>
                          <div className="btn-lang-container">
                            <Button className="btn btn-secondary btn-lang" onClick={() => this.changeLanguage('he')} >עברית</Button>
                            <Button className="btn btn-secondary btn-lang" onClick={() => this.changeLanguage('en')}>English</Button>
                          </div>
                        </ModalBody>
                      </Modal>

                      <Modal
                        isOpen={playLockDoor}
                        size="full"
                        className={"modal-language lang-" + i18n.language}
                      >
                    <div className="modal-header">
                      <Button
                        type="button close"
                        onClick={() => this.setState({ playLockDoor: false })}
                        aria-label="Close"
                      >
                        <span aria-hidden="true"><img src={iconClose} alt="Close"/></span>
                      </Button>
                    </div>
                    <ModalBody>
                      <FontAwesomeIcon className="icon" icon="lock-open" />
                      <h4 className="modal-title">{t("Please lock your door")}</h4>
                      </ModalBody>
                    </Modal>

                      <RoomButtons room={room} settings={settings} siteSettings={siteSettings} supplies={localProps.supplies} checklist={localProps.checklist} audioTracks={localProps.audioTracks} handleUpdateRoom={this.handleUpdateRoom} handleMusic={this.handleMusic} unmuteScreen={this.unmuteScreen} />
                      <Screen room={room} section={section} isLoadedSection={isLoadedSection} settings={settings} siteSettings={siteSettings} handleUpdateRoom={this.handleUpdateRoom} changeLanguage={this.changeLanguage} playSound={this.handlePlaySound} />
                      {siteSettings.emergencyButton?
                        <div className="mt-3 emergency-button"><Button className={"emergency " + (room.emergencyCall?"blink":"")} onClick={this.handleEmergency} type="secondary">{t("Emergency")}</Button></div>
                      :null}
                      <div className={"mt-3 mute-button" + (siteSettings.emergencyButton?" move-up":"")}>
                        <Button className={"btn-outline-primary btn-mute"} onClick={() => this.handleMusic(null, null, null, !this.state.screenMuted, this.state.screenMuted)} type="sm">
                          <FontAwesomeIcon className="icon" icon={this.state.screenMuted?"volume-mute":"volume-up"} />
                          <div>{t(this.state.screenMuted?"Unmute":"Mute")}</div> 
                        </Button>
                      </div>
                    </div>
                  </>
                )}
              </div>
            }
          </SettingsContext.Consumer>
        );
      }

    }

  }
}

export default withTranslation()(RoomView);
